import { SIGNAL_FINISH_CONTENT_RENDER, SIGNAL_START_STOPWATCH, SIGNAL_STOP_STOPWATCH} from '../constants/actionConstants'


// Updates store to reflect frame state
const ContentPositionReducer =  (state = {signalNewRender: 0.0, signalStartStopwatch: 0.0, stopwatchPauseFlag:false}, action) =>{
    switch(action.type){

        case SIGNAL_STOP_STOPWATCH:
            return {...state,  stopwatchPauseFlag: action.payload }

        case SIGNAL_START_STOPWATCH:
            return {...state, signalStartStopwatch: action.payload }

        case SIGNAL_FINISH_CONTENT_RENDER:
            return {...state, signalNewRender: action.payload.signalNewRender }
        default:
            return state ; 
    }
    
} ; 

export default ContentPositionReducer ; 
